import { useEffect, useMemo } from 'react';
import { useWizard } from 'react-use-wizard';

import { StepProgress } from '@/components/common/step-progress';

export const StepWrapper = ({
  children,
  onStepChange,
  showExitDialog,
}: {
  children?: JSX.Element;
  onStepChange: (step: number) => void;
  showExitDialog: boolean;
}) => {
  const stages = [
    'calibration.steps.step1',
    'calibration.steps.step2',
    'calibration.steps.step3',
  ];
  const { activeStep, goToStep } = useWizard();

  // useWizard hook start counting from 1, while step progress is 0 based
  const currentStep = useMemo(() => activeStep - 1, [activeStep]);

  // show step progress for step 0 (intro), 1 (counting chamber) and 2 (calibration) only
  const showProgressBar = useMemo(() => [0, 1, 2].includes(currentStep), [currentStep]);

  // callback for step change
  useEffect(() => {
    onStepChange(currentStep);
  }, [currentStep]);

  // if use try to close, we move to close step
  useEffect(() => {
    if (showExitDialog) {
      onStepChange(4);
      goToStep(4);
    }
  }, [showExitDialog]);

  return (
    <>
      {showProgressBar ? (
        <div className="hidden md:flex flex-col py-10 px-10">
          <StepProgress stages={stages} current={currentStep} />
        </div>
      ) : null}

      {children}
    </>
  );
};
